"use client";

import type { ISkill } from "types/Skills.type";
import RequestEndorsement from "components/_Pages/Profile/RequestEndorsement";

export interface RequestEndorsementModalContentV2Props {
  skill: ISkill;
  onClose?: () => void;
}

export function RequestEndorsementModalContentV2({
  skill,
  onClose,
}: RequestEndorsementModalContentV2Props) {
  return <RequestEndorsement skill={skill} onClose={onClose} />;
}
